import { FormattedMessage } from 'react-intl';
import metaTraderImg from '../../../assets/trader/metatrader5.png';
import iosImg from '../../../assets/trader/ios_new.png';
import androidImg from '../../../assets/trader/android.png';
import { getMetaTraderLinks } from 'config';

export const MetaTraderScreen = () => {
  const mtLinks = getMetaTraderLinks();

  if (!mtLinks) return null;

  return (
    <div className="meta-trader-content _flex _flex-col _flex-a-c _flex-j-a _text-c _ff-roboto">
      <div>
        <div className="meta-trader-link _m-b-50">
          <div className="_m-b-20 _lh-20">
            <FormattedMessage
              id="page.metaTrader_text_1"
              defaultMessage="Start using the trading platform by downloading the application from the link:"
            />
          </div>
          <a
            href={'./' + mtLinks.computer}
            rel="nofollow noreferrer"
            download
            className="trader-img _i-block"
          >
            <img src={metaTraderImg} alt="Link to download Trading Platform" width={248} />
          </a>
        </div>
        <div className="_m-b-20 _lh-20">
          <FormattedMessage
            id="page.metaTrader_text_3"
            defaultMessage="Download the app for Android or IOS:"
          />
        </div>
        <div className="_flex _flex-j-c">
          <a className="ios-link" href={mtLinks.ios} rel="nofollow noreferrer" target="_blank">
            <img
              className="ios-img"
              src={iosImg}
              alt="Link to download IOS Trading Platform"
              width={128}
            />
          </a>
          <a className="_m-l-20" href={'./' + mtLinks.android} rel="nofollow noreferrer" download>
            <img src={androidImg} width={128} alt="Link to download Android Trading Platform" />
          </a>
        </div>
      </div>
      <div className="_m-t-50">
        <div className="_m-b-20 _lh-20">
          <FormattedMessage
            id="page.metaTrader_text_2"
            defaultMessage="Or you can start using the trading platform directly from your browser:"
          />
        </div>
        <a
          className="_text-italic"
          href={mtLinks.browser}
          rel="nofollow noreferrer"
          target="_blank"
        >
          {mtLinks.browser}
        </a>
      </div>
    </div>
  );
};
